import {useTranslation} from '@aboutyou/i18n';
import {COLORS, GenericIconName, Icon} from '@aboutyou/ui-components';
import React, {memo} from 'react';

const CouponBadgeActiveContent: React.FC = () => {
  const {t} = useTranslation();

  return (
    <>
      <Icon
        asset={GenericIconName.CheckmarkCircle}
        size="S"
        fill={COLORS.White}
      />
      <span>{t('Your Coupon is Active!')}</span>
    </>
  );
};

export const MemoCouponBadgeActiveContent = memo(CouponBadgeActiveContent);
